import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page kn-width-full-with-menu" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_AttributesListBox = _resolveComponent("AttributesListBox")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_ProfileAttributesDetail = _resolveComponent("ProfileAttributesDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.profileAttributesManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_KnFabButton, {
              icon: "fas fa-plus",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm())),
              "data-test": "open-form-button"
            })
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AttributesListBox, {
          attributes: _ctx.attributes,
          loading: _ctx.loading,
          onDeleteAttribute: _ctx.onAttributeDelete,
          onSelectedAttribute: _ctx.onAttributeSelect,
          "data-test": "profile-attributes-listbox"
        }, null, 8, ["attributes", "loading", "onDeleteAttribute", "onSelectedAttribute"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.hideForm)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.profileAttributesManagement.title',
              hint: 'managers.profileAttributesManagement.hint'
            }, null, 8, ["title", "hint"]))
          : _createCommentVNode("", true),
        (!_ctx.hideForm)
          ? (_openBlock(), _createBlock(_component_ProfileAttributesDetail, {
              key: 1,
              selectedAttribute: _ctx.attribute,
              onRefreshRecordSet: _ctx.loadAllAttributes,
              onClosesForm: _ctx.closeForm,
              onDataChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dirty = true))
            }, null, 8, ["selectedAttribute", "onRefreshRecordSet", "onClosesForm"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}